import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import Swiper from 'swiper'

import { PresentationType, SlideType } from '../../../_types'

import { Jumbotron } from '../Jumbotron'
import MobileControls from '../PresentationControllers/MobileControls'
import ModalGridSlideSelector from '../Modal/ModalGridSlideSelector'

import './PresentationMobile.css'

export interface PresentationMobileProps extends PresentationType {
  slides: SlideType[]
  slidesPerView?: number
  activeIndex: number
  onSlideSelect: any
  onSelectNext: any
  onSelectPrev: any
  allowTouchMove?: boolean
  isMobile?: boolean
  isLandscape?: boolean
}
export const PresentationMobile: React.FC<PresentationMobileProps> = ({
  slides,
  activeIndex,
  onSlideSelect,
  onSelectNext,
  onSelectPrev,
  isMobile,
  isLandscape,
}) => {

  const [jumbotron, updateJumbotron] = useState(null as unknown as Swiper)
  const [slideSelector, updateSlideSelector] = useState(
    null as unknown as Swiper
  )

  useEffect(() => {
    if (slideSelector?.activeIndex !== activeIndex) {
      slideSelector?.slideTo(activeIndex, slideSelector?.params?.speed || 300)
      if (
        typeof slideSelector?.params?.slidesPerView === 'number' &&
        (activeIndex < jumbotron?.activeIndex ||
          activeIndex >
            jumbotron?.activeIndex + slideSelector?.params?.slidesPerView + 1)
      ) {
        jumbotron?.slideTo(activeIndex, jumbotron?.params?.speed || 300)
      }
    }
    jumbotron?.slideTo(activeIndex, jumbotron?.params?.speed || 300)
  }, [jumbotron, slideSelector, activeIndex])

  const handleSelectNext = () => {
    if (activeIndex < slides?.length - 1) {
      onSelectNext()
    }
  }
  const handleSelectPrev = () => {
    if (activeIndex > 0) {
      onSelectPrev()
    }
  }
  const handleSlideSelect = (idx: number) => {
    onSlideSelect(idx)
    setIsOpen(false)
  }

  const [isOpen, setIsOpen] = useState(false)
  const handleToggle = () => {
    setIsOpen((stale) => !stale)
  }

  return (
    <Box
      style={{
        backgroundColor: 'rgb(88, 88, 90)',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <ModalGridSlideSelector
        activeIndex={activeIndex}
        isOpen={isOpen}
        handleToggle={handleToggle}
        slides={slides}
        onSlideSelect={handleSlideSelect}
      />
      <Box
        sx={{
          width: '100%',
          userSelect: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <MobileControls handleToggle={handleToggle} />

        <Jumbotron
          slides={slides}
          activeIndex={activeIndex}
          onSliderUpdates={updateSlideSelector}
          onSelectNext={handleSelectNext}
          onSelectPrev={handleSelectPrev}
          allowTouchMove={true}
          isMobile={isMobile}
          isLandscape={isLandscape}
        />
      </Box>
    </Box>
  )
}

export default PresentationMobile
